<div class="mat-elevation-z8">
  <div class="filter-actions-line">
    <mat-form-field appearance="outline">
      <mat-label>Select Disposal Site</mat-label>
      <mat-select [formControl]="selectedSiteIdControl">
        @for (stream of sdcSites(); track stream.id) {
          <mat-option [value]="stream.id">{{ stream.siteName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width:250px">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
        <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button id="sdcSearchButton" data-testid="sdcSearchButton" mat-raised-button color="primary"
      (click)="onSearch()">
      <mat-icon>search</mat-icon>Search
    </button>
    <!-- Add Button -->
     @if(controlPermissions.addButton){
      <button mat-raised-button color="primary" (click)="onAddOrEdit(null, 'Add')">
        <mat-icon>add</mat-icon>
        Add
      </button>
     }
  </div>
</div>
<div class="mat-elevation-z8 mar-top-20">
  <mat-card>
    <mat-card-content>
      <div class="gridheight clear-both viewport">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
              <div>
                <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit"
                  (click)="onAddOrEdit(row, 'Edit')">
                  <mat-icon>edit</mat-icon>
                </button>
                @if(controlPermissions.delete){
                  <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDelete(row)" style="color: red;">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
          </ng-container>
          <ng-container matColumnDef="siteName">
            <th mat-header-cell *matHeaderCellDef>Site</th>
            <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
          </ng-container>          
          <ng-container matColumnDef="dateCaptured">
            <th mat-header-cell *matHeaderCellDef>Date Captured</th>
            <td mat-cell *matCellDef="let element"> {{element.dateCaptured | date:'MM/dd/yyyy'}} </td>
          </ng-container>
          <ng-container matColumnDef="tic">
            <th mat-header-cell *matHeaderCellDef>TIC</th>
            <td mat-cell *matCellDef="let element"> {{element.tic}} </td>
          </ng-container>
          <ng-container matColumnDef="vfa">
            <th mat-header-cell *matHeaderCellDef>VFA</th>
            <td mat-cell *matCellDef="let element"> {{element.vfa}} </td>
          </ng-container>
          <ng-container matColumnDef="ph">
            <th mat-header-cell *matHeaderCellDef>pH</th>
            <td mat-cell *matCellDef="let element"> {{element.ph}} </td>
          </ng-container>
          <ng-container matColumnDef="orp">
            <th mat-header-cell *matHeaderCellDef>ORP</th>
            <td mat-cell *matCellDef="let element"> {{element.orp}} </td>
          </ng-container>
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef>Entered By</th>
            <td mat-cell *matCellDef="let element"> {{element.createdBy}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- No Data Row -->
          <tr class="mat-row hover:bg-transparent" *matNoDataRow>
            <td class="mat-cell text-center text-gray-500 py-4" [attr.colspan]="displayedColumns.length"
                style="color: red;text-align: center;font-weight: 500;">
              No sdc data found for this site.
            </td>
          </tr>
        </table>
     </div>
    </mat-card-content>
  </mat-card>
</div>
